"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M20.366 0a3.637 3.637 0 0 1 3.628 3.44l.006.193v10.203a3.638 3.638 0 0 1-3.44 3.63l-.194.004h-8.2l-8.08 6.448h-.29c-.07 0-.159 0-.25-.052l-.067-.05a.505.505 0 0 1-.218-.278.52.52 0 0 1-.014-.285l2.168-5.865H3.634a3.638 3.638 0 0 1-3.63-3.44L0 13.755V3.633C0 1.728 1.559.108 3.444.005L3.634 0h16.732Zm0 .982-16.732.082c-1.34 0-2.48 1.088-2.565 2.41l-.005.16v10.202c0 1.34 1.088 2.48 2.41 2.565l.16.005h2.612c.213 0 .324.11.413.198.079.08.105.192.114.313l.005.185-.008.045-1.797 4.714 6.664-5.346a.368.368 0 0 1 .264-.108h8.465c1.339 0 2.479-1.089 2.564-2.411l.006-.16V3.552c0-1.34-1.089-2.479-2.41-2.565l-.16-.005ZM7.47 7.346c.968 0 1.756.788 1.756 1.757A1.757 1.757 0 1 1 7.47 7.346Zm4.897 0a1.757 1.757 0 1 1-1.756 1.757c0-.97.788-1.757 1.756-1.757Zm4.898 0a1.757 1.757 0 1 1-1.756 1.757c0-.97.787-1.757 1.756-1.757ZM7.47 8.41c-.42 0-.693.272-.693.693 0 .42.272.692.693.692.421 0 .692-.271.692-.692 0-.421-.27-.693-.692-.693Zm4.897 0c-.42 0-.692.272-.692.693 0 .42.271.692.692.692.421 0 .693-.271.693-.692 0-.421-.272-.693-.693-.693Zm4.898 0c-.421 0-.692.272-.692.693 0 .42.27.692.692.692.42 0 .692-.271.692-.692 0-.421-.271-.693-.692-.693Z",
    clipRule: "evenodd"
  })]
});